<template>
  <div class="home" :style="`background: ${ toRgba(activityData.themeColor) }`">
    <div class="home-header">
      <img :src="activityData.image" alt="banner" />
      <div class="home-header-rule" @click="isShowRule = true" v-if="!activityData.isHideVote && !activityData.isHideRule" ></div>
    </div>

    <div class="home-input-box">
      <input
        @keyup="codeFn"
        v-model="inputVal"
        ref="ipt"
        class="home-input"
        type="text"
        placeholder="请输入标题或者编号进行搜索~"
      />
      <div @click="handleIptChange" class="home-input-btn"></div>
      <div @click="handleIptClear" v-if="inputVal" class="home-input-clear">
        x
      </div>
    </div>

    <div :class="{ 'home-content': true, 'home-content-hasBack': isShowBack }">
      <div class="home-content-triangle"><div :style="`border-top: 100vw solid ${ activityData.themeColor || '#1E3485' };`"></div></div>
      <div class="home-content-body">
        <div v-if="activityData.voteIsApply && !isActiveEnd && !isApplyTime()" class="active-apply" @click="handleApply"></div>
        <div v-if="isActiveEnd" class="active-end"></div>
        <div v-if="fetchLoading" class="data-list-loading">
          <Loading />
        </div>
        <div
          v-if="!fetchLoading && dataList.length > 0"
          ref="dataListNode"
          class="data-list"
        >
          <div class="data-item" v-for="(item, index) in dataList" :key="item.id">
            <ListItem
              :activityData="activityData"
              :data="item"
              :index="index"
              :successCallback="changeVotes"
            />
            <!-- <div v-if='index !== dataList.length - 1' class='dash'></div> -->
          </div>
        </div>
        <div
          v-if="!fetchLoading && dataList.length === 0"
          class="data-list-empty"
        >
          <span>{{ "暂无数据" }}</span>
        </div>
        <div v-else class="data-list-bottom">到底了</div>
      </div>
    </div>

    <!-- <div v-if="isShowBack" class="data-list-back">
      <div @click="handleBack" class="data-list-back_btn"></div>
    </div> -->

    <div class="rule-box" v-if="isShowRule">
      <div class="rule-mask"></div>

      <div class="rule-content">
        <div v-html="activityData.desc || ''"></div>
      </div>
      <div class="rule-btn" @click="isShowRule = false"></div>
    </div>
    <dialog-component
      @loginEvent="getUserInfon"
      @wxauthorizeEvent="wxAuthorizeCallback"
      :baseData="baseData"
    ></dialog-component>
  </div>
</template>

<script>
import CONFIG from "@/utils/config";
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";
import ListItem from "@/components/BtfvoteListItem.vue";
import Loading from "@/components/Loading.vue";
import { scrollToY } from "@/utils/scrollTo";
import DialogComponent from "@/components/Dialog";

import { mapState, mapActions } from "vuex";
import moment from 'moment';

export default {
  name: "home",
  data() {
    return {
      isShowRule: false,
      fetchLoading: false,
      copyList: [],
      dataList: [],
      inputVal: "",
      listOptions: {
        page: 1, // 当前页   默认值-1
        rows: 10, // 每一页数量   默认值-10
        keyword: "", //搜索关键词
        field: "", //需要搜索data数据对应的字段
        // sort: "votes",
        sort: "info.no",
      },
      isReachBottom: false,
      reachBottomDistance: 100,
      scrollHeight: 0,
      offsetHeight: 0,
      openid: "",
    };
  },
  components: {
    ListItem,
    Loading,
    DialogComponent,
  },
  props: ["activityData", "baseData"],
  computed: {
    ...mapState([
      "shareData",
      "pageLoading",
      "aid",
      "isPlayAudio",
      "currentItemId",
      "userInfo",
    ]),
    isActiveEnd() {
      const activityData = this.activityData || {};
      const { endTime = "" } = activityData;
      const now = new Date().getTime();
      const end = new Date(endTime).getTime();
      return endTime && now > end;
    },
    isShowBack() {
      return this.copyList.length !== this.dataList.length;
    },
  },
  watch: {
    isReachBottom(v) {
      if (v) {
        // 加载下一页
        this.listOptions.page += 1;
        this.getList({}, true);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setPageLoadingAsync(false);
    });
    let dom = document.querySelector(".home");
    dom.addEventListener("scroll", (e) => this.onScroll(e));
    this.getList();
    this.share();
  },
  methods: {
    ...mapActions(["setPageLoadingAsync", "setUserInfoAsync"]),
    getUserInfon() {
      this.setUserInfoAsync();
    },
    wxAuthorizeCallback(openid) {
      let _this = this;
      let verifyOpenid = `${_this.userInfo.user_id.toString(
        36
      )}_${openid}_${(+moment().format("YYYYMMDD")).toString(36)}`;
      _this.userInfo.openid = openid;
      _this.openid = verifyOpenid;
      store.commit("setUserInfo", _this.userInfo);
    },
    share() {
      COVER.share(this.shareData);
    },
    changeVotes() {
      this.getList({}, true);
    },
    getList(o = {}, bool) {
      if (!bool) {
        this.fetchLoading = true;
      }
      const num = this.inputVal;
      this.listOptions.aid = this.aid;
      this.listOptions.keyword = num;
      this.listOptions.field = "title";
      if (num > 0) {
        this.listOptions.field = "no";
      }

      COVER.$get("/vote", this.listOptions).then((res) => {
        if (res.errno === 0) {
          const { page, rows } = this.listOptions;
          const { list, total } = res.data;
          this.isReachBottom = page * rows >= total;
          this.copyList = list;
          this.dataList = page == 1 ? list : this.dataList.concat(list);
        }
        if (!bool) {
          this.fetchLoading = false;
        }
      });
    },
    codeFn(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.handleIptChange();
        this.$refs.ipt && this.$refs.ipt.blur();
      }
    },
    handleBack() {
      this.inputVal = "";
      this.dataList = this.copyList;
    },
    handleIptClear() {
      this.inputVal = "";
      this.listOptions.page = 1;
      this.getList();
    },
    handleIptChange(e) {
      this.listOptions.page = 1;
      this.getList();
    },
    onScroll(e) {
      let { scrollTop, scrollHeight, clientHeight } = e.target;
      let currentHeight = scrollTop + clientHeight + this.reachBottomDistance;
      if (this.isReachBottom) {
        return;
      }
      if (currentHeight < scrollHeight) {
        this.isReachBottom = false;
      } else {
        this.isReachBottom = true;
        console.log("触底");
      }
    },
    toRgba(c) {
      if (!c) {
        return;
      }
      return COVER.hexToRgba(c, 0.9);
    },
    isApplyTime() {
      const { applyTime } = this.activityData;
      if (!applyTime || !applyTime[0]) {
        return true;
      }
      // 报名时间未开始
      if (moment().unix() < moment(applyTime[0]).unix()) {
        return true;
      }

      // 报名时间已结束
      if (moment().unix() > moment(applyTime[1]).unix()) {
        return true;
      }

      return;
    },
    handleApply() {
      window.location.href = '/apply/#/?id=' + this.aid;
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  background: #2b4aa7;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  font-size: 3vw;

  .home-input-box {
    width: 100vw;
    box-sizing: border-box;
    height: 1.1733333rem;
    display: flex;
    position: relative;
  }
  .home-input-btn {
    background: url("../../../assets/images/btfvote/ss-btn.png") no-repeat center top;
    background-size: 100%;
    height: 100%;
    width: 2.293333rem;
  }
  .home-input {
    flex: 1;
    appearance: none;
    font-size: 0.4rem;
    line-height: 1;
    border: 2px solid #000;
    border-right: none;
    padding-left: 0.3rem;
    box-sizing: border-box;
    outline: none;
    border-radius: 0;
    padding-right: 0.5rem;
    &-clear {
      position: absolute;
      top: 50%;
      right: 2.5rem;
      transform: translateY(-50%);
      font-size: 0.5rem;
    }
  }

  .data-list-empty {
    padding: 1.5rem;
    text-align: center;
    font-size: 0.4rem;
    color: #fff;
  }
  .data-list-bottom {
    text-align: center;
    font-size: 0.3rem;
    color: #fff;
  }
  &-header {
    position: relative;
    height: 5.6rem;
    // background: url("../../../assets/images/btfvote/banner.png") no-repeat  center top;
    background-size: 100%;

    &-rule {
      position: absolute;
      bottom: 0.1rem;
      right: 0;
      cursor: pointer;
      background: url("../../../assets/images/btfvote/rule.png") no-repeat
        center top;
      background-size: 100%;
      width: 3.506666rem;
      height: 0.933333rem;
    }
  }

  &-content-triangle {
    position: relative;
    width: 100%;
    z-index: 1;
    div {
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-left: 100vw solid transparent;
      border-bottom: 100vw solid transparent;
      border-top: 100vw solid transparent;
    }
  }

  &-content-body {
    position: absolute;
    z-index: 2;
    padding: 0.2666666rem;
    width: 100%;
    box-sizing: border-box;
  }

  &-content {
    // padding: 0.2666666rem;
    // background: url("../../../assets/images/btfvote/fill.png") no-repeat center top;
    background-size: 100%;
    min-height: 10.0266666rem;
    position: relative;

    &-hasBack {
      padding-bottom: 0.8rem;
    }

    .active-end {
      background: url("../../../assets/images/btfvote/end.png") no-repeat center
        top;
      background-size: 100%;
      width: 100%;
      height: 1.88rem;
    }
    .active-apply {
      background: url("../../../assets/images/btfvote/apply_btn.png") no-repeat center
        top;
      background-size: 100%;
      width: 100%;
      height: 1.88rem;
    }
    .data-list-loading {
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .data-list {
      padding: 4vw 0;
      .dash {
        border: 1px dashed #fff;
        margin: 5vw 0;
        width: 200%;
        transform: scale(0.5);
        transform-origin: left;
      }
    }
  }

  .data-list-back {
    border-top: 2px solid #000;
    height: 1.44rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100vw;
    bottom: 0;
    background: #2b4aa7;

    &_btn {
      background: url("../../../assets/images/btfvote/back.png") no-repeat
        center top;
      background-size: 100%;
      width: 2.6666666rem;
      height: 1.066666rem;
    }
  }

  .rule-box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
    animation: fade 0.5s 0s ease forwards;
    width: 100vw;
    height: 100vh;

    .rule-mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 1002;
      background: rgba(#000000, 0.8);
    }

    .rule-btn {
      position: fixed;
      left: 50%;
      top: 14.1rem;
      transform: translateX(-50%);
      background: url("../../../assets/images/btfvote/quxiao.png") no-repeat
        center top;
      background-size: 100%;
      width: 1.786666rem;
      height: 2rem;
      z-index: 1003;
    }

    .rule-content {
      width: 8.933333rem;
      height: 11.573333rem;
      box-sizing: border-box;

      position: fixed;
      padding: 0.533333rem;
      padding-top: 2rem;
      left: 50%;
      top: 2.093333rem;
      transform: translateX(-50%);
      z-index: 1003;
      background: url("../../../assets/images/btfvote/rule-modal.png") no-repeat
        center top;
      background-size: 100%;
      & > div {
        overflow-y: scroll;
        width: 100%;
        height: 100%;
      }
      /deep/ p {
        margin: 1.6vw 0;
        line-height: 1.5em;
        font-size: 0.37333333rem;
        font-weight: 700;
      }
    }
  }
}
</style>